import { render } from "./MessageModal.vue?vue&type=template&id=2bbc6814&scoped=true"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"

import "./MessageModal.vue?vue&type=style&index=0&id=2bbc6814&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Stage-Leadership_Admin_Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbc6814"]])

export default __exports__